import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=52732547&scoped=true&"
import script from "./summaryTable.vue?vue&type=script&lang=js&"
export * from "./summaryTable.vue?vue&type=script&lang=js&"
import style0 from "./summaryTable.vue?vue&type=style&index=0&id=52732547&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52732547",
  null
  
)

export default component.exports